<template>
  <div id="not-found" class="fadein full-height w-full fadein">
    <div class="h-full flex justify-center items-center flex-col">
      <h1 class="text-4xl font-extrabold text-white mb-3">404</h1>
      <h2 class="text-white text-xl">{{ t('headline') }}</h2>
      <div class="flex mt-7">
        <div v-if="!state.userIsLoggedIn" class="flex items-center soft-btn px-3 py-2 rounded-3xl cursor-pointer mr-3" @click="router.push('/')">
          <a class="text-ml text-white">{{ t('backtolanding') }}</a>
        </div>
        <div v-else class="flex items-center regular-btn px-3 py-2 rounded-3xl cursor-pointer mr-3" @click="router.push('/dashboard')">
          <a class="text-ml text-white">{{ t('backtodashboard') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeMount, reactive } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { useUserStore } from '@/composables/userStore'
  import { useRouter } from 'vue-router'

  const userStore = useUserStore()

  const messages = {
    no: {
      headline: 'Denne siden eksisterer ikke',
      backtolanding: 'Tilbake til startsiden',
      backtodashboard: 'Tilbake til dashboard',
    },
    en: {
      headline: 'The page you requested does not exist',
      backtolanding: 'Back to the Landingpage',
      backtodashboard: 'Back to the Dashboard',
    },
  }

  const { t } = useI18n({ messages })
  const router = useRouter()

  const state = reactive({
    userIsLoggedIn: false,
  })

  onBeforeMount(async () => {
    const { authenticated } = await userStore.actions.isValidSession()
    state.userIsLoggedIn = authenticated
  })
</script>

<style scoped>
  #not-found {
    background: linear-gradient(180deg, var(--lp-blue), var(--lp-gray));
    background-size: 100% 1100px;
    background-repeat: no-repeat;
    overflow: visible;
    min-height: 100vh;
  }
</style>
